'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';
const __endpoints = require('endpoints.service');

export default class StoreContinentTags extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
		];
		this.settings = {
			name: 'StoreContinentTags',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			canManipulate: () => validAccess(undefined, ['Global BI Configuration']),
			translationPath: 'ADMINISTRATION.STORE_CONTINENT_TAGS',
			endpoint: __endpoints.collection.administration.store_continent_tags,
		};
		this.init();
		return this;
	}
}
